<template>
  <div>
    <svg
      version="1.1"
      id="レイヤー_1"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
      x="0px"
      y="0px"
      viewBox="0 0 400 45"
      style="enable-background:new 0 0 400 45;"
      xml:space="preserve"
      :style="svgStyles"
    >
      <title>bizoope_logo</title>
      <path
        :style="svgStyles1"
        d="M78.04,44.06L78.04,44.06c1.59,0,2.87-1.29,2.87-2.87v-25.6c0-1.59-1.29-2.87-2.87-2.87h0
        c-1.59,0-2.87,1.29-2.87,2.87v25.6C75.17,42.77,76.46,44.06,78.04,44.06z"
      />
      <path
        :style="svgStyles1"
        d="M5.4,32.96L5.4,32.96c1.59,0,2.87-1.29,2.87-2.87v-14.8c0-1.59-1.29-2.87-2.87-2.87h0
        c-1.59,0-2.87,1.29-2.87,2.87v14.8C2.53,31.68,3.82,32.96,5.4,32.96z"
      />
      <path
        :style="svgStyles1"
        d="M92.1,36.97l52.92-23.86c2.93-1.32,4.37-4.4,3.48-7.55c-0.78-2.76-3.44-4.57-6.32-4.57l-50.89,0
        c-1.59,0-2.87,1.29-2.87,2.87v0c0,1.59,1.29,2.87,2.87,2.87h51.11c0.13,0,0.49,0,0.59,0.48c0.1,0.47-0.22,0.62-0.34,0.67
        L89.74,31.74c-2.93,1.32-4.37,4.4-3.48,7.55c0.78,2.76,3.44,4.57,6.32,4.57l55.7,0c1.59,0,2.87-1.29,2.87-2.87v0
        c0-1.59-1.29-2.87-2.87-2.87H92.35c-0.13,0-0.49,0-0.59-0.47C91.66,37.17,91.98,37.03,92.1,36.97z"
      />
      <path
        :style="svgStyles2"
        d="M191.48,0.94h-25.62c-11.89,0-21.56,9.67-21.56,21.56s9.67,21.56,21.56,21.56h25.62
        c11.89,0,21.56-9.67,21.56-21.56S203.37,0.94,191.48,0.94z M207.3,22.5c0,8.72-7.09,15.82-15.82,15.82h-25.62
        c-8.72,0-15.82-7.1-15.82-15.82s7.1-15.82,15.82-15.82h25.62C200.2,6.68,207.3,13.78,207.3,22.5z"
      />
      <path
        :style="svgStyles2"
        d="M260.22,0.94H234.6c-11.89,0-21.56,9.67-21.56,21.56s9.67,21.56,21.56,21.56h25.62
        c11.89,0,21.56-9.67,21.56-21.56S272.1,0.94,260.22,0.94z M260.22,38.32H234.6c-8.72,0-15.82-7.1-15.82-15.82
        s7.09-15.82,15.82-15.82h25.62c8.72,0,15.82,7.1,15.82,15.82S268.94,38.32,260.22,38.32z"
      />
      <path
        :style="svgStyles1"
        d="M381.21,10.93l-18.52,0c-8.98,0-16.65,6.97-16.98,15.94c-0.35,9.42,7.21,17.19,16.55,17.19h19.45
        c4.96,0,9.56-2.21,12.66-5.89c1.45-1.72,0.34-4.37-1.89-4.65v0c-0.99-0.13-1.95,0.3-2.6,1.05c-2.04,2.37-5,3.74-8.17,3.74
        l-19.11,0c-5.84,0-10.88-4.47-11.15-10.3c-0.29-6.2,4.67-11.34,10.81-11.34h19.45c4.88,0,9.1,3.25,10.4,7.87
        c0.01,0.02-0.01,0.04-0.03,0.04l-35.64,0c-1.61,0-2.91,1.3-2.91,2.91v0c0,1.61,1.3,2.91,2.91,2.91h37.92
        c2.22,0,4.03-1.87,3.86-4.09c0-0.01,0-0.02,0-0.03C397.44,17.55,389.98,10.93,381.21,10.93z"
      />
      <path
        :style="svgStyles1"
        d="M339.32,0.94h-46.32c-6.2,0-11.22,5.02-11.22,11.22v29.03c0,1.59,1.29,2.87,2.87,2.87l0,0
        c1.59,0,2.87-1.29,2.87-2.87V12.16c0-3.03,2.45-5.48,5.48-5.48l46.11,0c2.78,0,5.28,1.99,5.62,4.76c0.41,3.31-2.17,6.14-5.41,6.14
        h-46.35c-1.59,0-2.87,1.29-2.87,2.87v0c0,1.59,1.29,2.87,2.87,2.87l46,0c6.03,0,11.25-4.63,11.53-10.65
        C350.8,6.25,345.67,0.94,339.32,0.94z"
      />
      <path
        :style="svgStyles1"
        d="M62.64,20.48c1.93-2.56,2.79-5.78,2.34-9.03c-0.85-6.1-6.29-10.51-12.45-10.51c-11.57,0-39.11,0-48.06,0
        c-1.59,0-2.87,1.29-2.87,2.87v0c0,1.59,1.29,2.87,2.87,2.87l48.16,0c3.46,0,6.5,2.6,6.72,6.06c0.24,3.76-2.75,6.89-6.46,6.89
        H15.95c-1.59,0-2.87,1.29-2.87,2.87v0.02c0,1.59,1.29,2.87,2.87,2.87h41.92c3.53,0,6.48,2.64,6.71,6.02
        c0.14,2.11-0.71,4.1-2.39,5.47c-1.19,0.98-2.73,1.44-4.27,1.44l-53.45,0c-1.59,0-2.87,1.29-2.87,2.87v0
        c0,1.59,1.29,2.87,2.87,2.87H57.8c6.71,0,12.21-5.1,12.51-11.62c0.25-5.28-2.85-10.01-7.67-11.91
        C62.63,20.52,62.63,20.5,62.64,20.48z"
      />
      <circle :style="svgStyles2" cx="78.04" cy="5.57" r="4.63" />
    </svg>
  </div>
</template>

<script>
export default {
  props: {
    size: {
      type: String,
      default: 'small',
    },
  },
  computed: {
    svgStyles1() {
      return {
        fill: '#6ea521',
      }
    },
    svgStyles2() {
      return {
        fill: '#e69700',
      }
    },
    svgStyles() {
      let size
      switch (this.size) {
        case 'small':
          size = 200
          break
        case 'middle':
          size = 400
          break
        case 'big':
          size = 800
          break
      }
      return {
        width: `${size}px`,
      }
    },
  },
}
</script>
